module.exports = __webpack_public_path__ + "media/images/workplace/shorties_partying_face-31023d1c93bbc4a9eda078915a61651a.png";